<template>
  <div class="content">
    <div class="ttile">
      文章
      <p>
        说明：可直接添加文章，文章随着文章库下架，app/小程序端文章也会隐藏。
      </p>
    </div>

    <div class="select_type">
      <p>选择类型</p>
      <TypeGroup v-model="curComponent.type" :options="typeOptions" />
    </div>

    <div class="select_type add_title">
      <p>添加文章</p>
      <span>最多添加30篇文章，拖拽可排序。</span>
      <UploadArticle v-model="curComponent.articleList" addBtnText="选择文章" />
    </div>

    <div class="select_type">
      <p>样式基础设置</p>
      <SpRadio
        v-model="curComponent.showTitle"
        label="文章名称"
        :options="radioOptions"
      />
      <SpRadio
        v-model="curComponent.showDec"
        label="文章描述"
        :options="radioOptions"
      />
      <SpRadio
        v-model="curComponent.showRelaeaseTime"
        label="发布时间"
        :options="radioOptions"
      />
      <SpRadio
        v-model="curComponent.showReleaser"
        label="发布人"
        :options="radioOptions"
      />
      <SpRadio
        v-model="curComponent.showReadPeopleCount"
        label="阅读人数"
        :options="radioOptions"
      />
      <SpRadio
        v-model="curComponent.showStarPeopleCount"
        label="点赞人数"
        :options="radioOptions"
      />
      <SpSlider v-model="curComponent.radius" label="文章圆角值" />
      <SpSlider v-model="curComponent.mx" label="页面边距" />
      <SpSlider v-model="curComponent.articleMargin" label="文章边距" />
      <SpSlider v-model="curComponent.mb" label="页面底部间距" />
    </div>
  </div>
</template>

<script>
import { typeOptions, radioOptions } from "./options.js";
import SpRadio from "../../../components/SpRadio";
import SpSlider from "../../../components/SpSlider";
import TypeGroup from "./components/TypeGroup";
import UploadArticle from "./components/UploadArticle";
export default {
  inject: ["control"],
  components: {
    SpRadio,
    SpSlider,
    TypeGroup,
    UploadArticle
  },
  computed: {
    curComponent: {
      get() {
        return this.control.curComponent;
      },
      set(val) {
        this.control.curComponent = val;
      }
    }
  },
  data() {
    return {
      radioOptions: Object.freeze(radioOptions),
      typeOptions: Object.freeze(typeOptions)
    };
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    p {
      font-size: 10px;
      color: #999999;
      margin-top: 4px;
    }
  }

  .select_type {
    padding: 20px 24px 0 24px;
    > p {
      font-weight: 500;
      font-size: 14px;
      color: #000000;
    }
    > span {
      display: block;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      padding-top: 10px;
    }
    /deep/ .slider-content,
    .sp-radio {
      margin-bottom: 20px;
    }
  }

  .add_title {
    padding-top: 30px;
    > span {
      padding-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/articleComponents/Article/Attr.vue